const EXT_TO_MIME: Record<string, string> = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
  gif: 'image/gif',
  svg: 'image/svg+xml',
  pdf: 'application/pdf',
};

function guessMimeFromUrl(url: string): string | null {
  const path = url.split('?')[0].split('#')[0];
  const ext = path.split('.').pop()?.toLowerCase();
  return ext && EXT_TO_MIME[ext] ? EXT_TO_MIME[ext] : null;
}

export async function convertUrlToFile(
  url: string,
  filename?: string,
  mimeType?: string
): Promise<File> {
  const response = await fetch(url);
  const blob = await response.blob();

  const fileName = filename || url.split('/').pop() || 'file';

  // Prefer an explicit MIME, then a URL extension guess (most reliable for our
  // S3 bucket, which often serves files with a generic Content-Type), then the
  // blob's own type if it's specific enough, then a safe image default.
  const urlGuess = guessMimeFromUrl(url);
  const blobType =
    blob.type && !blob.type.toLowerCase().includes('octet-stream')
      ? blob.type
      : null;
  const type = mimeType || urlGuess || blobType || 'image/jpeg';

  return new File([blob], fileName, { type });
}
